export default __webpack_public_path__ + "static/upwaltham-d8ccc99ffb4a751ca7a6b658c2860641.jpg";